import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { hide } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['bookmarkCta', 'bookmarkIcon'];
  static values = {
    articleId: Number,
  };
  static classes = ['bookmarkIconActive', 'bookmarkIconInactive'];

  connect() {
    if (CurrentUser.isGuest()) {
      hide(this.bookmarkCtaTarget);
    } else {
      this.updateBookmarkDisplay();
    }
  }

  updateBookmarkDisplay() {
    this.setBookmarkIconState(
      CurrentUser.bookmarks().includes(this.articleIdValue)
    );
  }

  setBookmarkIconState(isActive) {
    this.bookmarkIconTarget.classList.toggle(
      this.bookmarkIconActiveClass,
      isActive
    );
    this.bookmarkIconTarget.classList.toggle(
      this.bookmarkIconInactiveClass,
      !isActive
    );
  }
}
